// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"35676a0e","1176":"35676a0e","2319":"35676a0e","5751":"35676a0e"}[chunkId] + ".chunk.css";
};